

/// <reference path="CoreEntityUpdatedBy.ts" />

// Generated class CoreItem_ManagedObject

class CoreItem_ManagedObject extends CoreEntityUpdatedBy
{

    // Property: name
    set name(value:string) {
        this.setValueForKey(value, 'name');
    }
    get name():string {
        return this.valueForKey('name');
    }
    set namePrimitiveValue(value:string) {
        this.setPrimitiveValueForKey(value, 'name');
    }
    get namePrimitiveValue():string {
        return this.primitiveValueForKey('name');
    }
    // Relationship: purchaseLedgerAccount
    set purchaseLedgerAccount(value:LedgerAccount) {
        this.setValueForKey(value, 'purchaseLedgerAccount');
    }
    get purchaseLedgerAccount():LedgerAccount {
        return this.valueForKey('purchaseLedgerAccount') as LedgerAccount;
    }
    // Relationship: salesLedgerAccount
    set salesLedgerAccount(value:LedgerAccount) {
        this.setValueForKey(value, 'salesLedgerAccount');
    }
    get salesLedgerAccount():LedgerAccount {
        return this.valueForKey('salesLedgerAccount') as LedgerAccount;
    }
}
